import data from '../assets/data'

const getRooms = () => {
  return data.roomsList
}

const getRoom = (id) => {
  return data.rooms[id]
}

const getBundle = (id) => {
  return data.bundles[id]
}

const getItem = (id) => {
  return data.items[id]
}

const initializeState = () => {
  const bundles = Object.entries(data.bundles)
  let state = {}
  for (let [key, val] of bundles) {
    let bundle = {}
    val.items.forEach((item) => {
      bundle[item] = false
    })
    state[key] = bundle
  }
  return state
}

/*
const formatData = (t) => {
  let output = {}
  t.forEach((item) => {
    if (!data.items[item]) {
      let split = item
        .split('_')
        .map((word) => word[0].toUpperCase() + word.slice(1))

      output[item] = {
        name: split.join(' '),
        description: 'gggg',
        url: 'https://stardewvalleywiki.com/' + split.join('_'),
        img: split.join('_') + '.png',
      }
    }
  })
  return output
}
*/

export { getRooms, getRoom, getBundle, getItem, initializeState }
